import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const InputText = (props) => {
  const {
    input,
    placeholder,
    label,
    type,
    asterisk,
    disabled,
    meta: { touched, error },
    mode,
  } = props;

  const { t } = useTranslation("master");

  // Local state to manage input value
  const [localValue, setLocalValue] = useState(input.value);

  // Effect to sync local state with Redux state
  useEffect(() => {
    setLocalValue(input.value);
  }, [input.value]);

  // Determine if the input should be disabled
  const isDisabled = () => {
    const nonEditableFields = [
      "districtCode",
      "talukaCode",
      "villageCode",
      "userCode",
      "phcCode",
      "subcenterCode",
      "roleCode",
      "facultyCode",
      "programCode",
      "schemeCode",
      "activityCode",
      "lgbIdCode",
      "corporation_council_code",
    ];
    if (mode === "Update") {
      return nonEditableFields.includes(input.name) && input.value !== "";
    }
    return false;
  };

  const handleChange = (e) => {
    setLocalValue(e.target.value); // Update local state
  };

  const handleBlur = () => {
    input.onChange(localValue); // Update Redux state only on blur
  };

  const disabledClass = isDisabled()
  ? "bg-gray-200 cursor-not-allowed border-gray-300"
  : "";

  return (
    <>
      <label className="input-label" htmlFor={input.name}>
        <span className="astoricstyle">{asterisk}</span>
        {t(label)}
      </label>
      <input
        id={input.name}
        type={type}
        className={`input-style p-inputtext ${
          touched && error ? "border-red-500" : ""
        } ${disabledClass}`}
        placeholder={placeholder}
        value={localValue}
        onChange={handleChange}
        onBlur={handleBlur}
        disabled={disabled || isDisabled()}
      />
      {touched && error && <span className="text-red-500">{error}</span>}
    </>
  );
};
export default InputText;